/* eslint-disable no-param-reassign */
/* eslint-disable max-classes-per-file */
import registerNamespace from './locales';
import getDynamicDateRange from './dynamicDateRange';
import { OptionsMap } from './types';

export const optionNamespace = registerNamespace('src/hooks/modifiers/options.ts');

export class GroupOptions {
  static enum = {
    SIMPLE: 'simple',
    ADVANCED: 'advanced',
  } as const;

  static map: OptionsMap<typeof this.enum> = {
    simple: { label: 'simple', value: 'simple', id: 'simple' },
    advanced: { label: 'advanced', value: 'advanced', id: 'advanced' },
  };

  static list = Object.values(this.map);
}

export class TypeSimpleOptions {
  static enum = {
    VALUES: 'values',
    NOT_VALUES: 'not-values',
  } as const;

  static map: OptionsMap<typeof this.enum> = {
    values: {
      value: 'values', label: 'values', id: 'values', description: 'values-desc',
    },
    'not-values': {
      value: 'not-values', label: 'not-values', id: 'not-values', description: 'not-values-desc',
    },
  };

  static list = Object.values(this.map);
}

export class TypePeriodOptions {
  static enum = {
    CURRENTMONTH: 'current_month',
    CURRENTYEAR: 'current_year',
    CURRENTWEEK: 'current_week',
    CURRENTQUARTER: 'current_quarter',
    CURRENTSEMESTER: 'current_semester',
  } as const;

  static map: OptionsMap<typeof this.enum> = {
    // filtros de mês
    current_month: {
      value: 'current_month',
      label: 'current_month',
      id: 'current_month',
      description: 'current_month-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingM', 0).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingM', 0).firstInterval.endDate,
      },
    },
    // filtros de ano
    current_year: {
      value: 'current_year',
      label: 'current_year',
      id: 'current_year',
      description: 'current_year-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingY', 0).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingY', 0).firstInterval.endDate,
      },
    },
    // Filtros de semana
    current_week: {
      value: 'current_week',
      label: 'current_week',
      id: 'current_week',
      description: 'current_week-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingW', 0).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingW', 0).firstInterval.endDate,
      },
    },
    // filtros de trimestre
    current_quarter: {
      value: 'current_quarter',
      label: 'current_quarter',
      id: 'current_quarter',
      description: 'current_quarter-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingQ', 0).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingQ', 0).firstInterval.endDate,
      },
    },
    // Filtros de semestre
    current_semester: {
      value: 'current_semester',
      label: 'current_semester',
      id: 'current_semester',
      description: 'current_semester-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingS', 0).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingS', 0).firstInterval.endDate,
      },
    },
  };

  static list = Object.values(this.map);
}

export class TypeNumberOptions {
  static enum = {
    GREATER: 'greater',
    GREATERINC: 'greater_inc',
    LESSER: 'lesser',
    LESSERINC: 'lesser_inc',
    BETWEEN: 'between',
    NOT_BETWEENINC: 'not-between_inc',
    BETWEENINC: 'between_inc',
    NOT_BETWEEN: 'not-between',
  } as const;

  static map: OptionsMap<typeof this.enum> = {
    greater: {
      value: 'greater',
      label: 'greater',
      id: 'greater',
      description: 'greater-desc',
    },
    greater_inc: {
      value: 'greater_inc',
      label: 'greater_inc',
      id: 'greater_inc',
      description: 'greater_inc-desc',
    },
    lesser: {
      value: 'lesser',
      label: 'lesser',
      id: 'lesser',
      description: 'lesser-desc',
    },
    lesser_inc: {
      value: 'lesser_inc',
      label: 'lesser_inc',
      id: 'lesser_inc',
      description: 'lesser_inc-desc',
    },
    between: {
      value: 'between',
      label: 'between',
      id: 'between',
      description: 'between-desc',
    },
    'not-between_inc': {
      value: 'not-between_inc',
      label: 'not-between_inc',
      id: 'not-between_inc',
      description: 'not-between_inc-desc',
    },
    between_inc: {
      value: 'between_inc',
      label: 'between_inc',
      id: 'between_inc',
      description: 'between_inc-desc',
    },
    'not-between': {
      value: 'not-between',
      label: 'not-between',
      id: 'not-between',
      description: 'not-between-desc',
    },
  };

  static list = Object.values(this.map);
}

export class TypeTextOptions {
  static enum = {
    MOST: 'most',
    NOT_MOST: 'not-most',
    MOSTINC: 'most_inc',
    NOT_MOSTINC: 'not-most_inc',
    LEAST: 'least',
    NOT_LEAST: 'not-least',
    LEASTINC: 'least_inc',
    NOT_LEASTINC: 'not-least_inc',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'not-contains',
  } as const;

  static map: OptionsMap<typeof this.enum> = {
    most: {
      value: 'most',
      label: 'most',
      id: 'most',
      description: 'most-desc',
    },
    'not-most': {
      value: 'not-most',
      label: 'not-most',
      id: 'not-most',
      description: 'not-most-desc',
    },
    most_inc: {
      value: 'most_inc',
      label: 'most_inc',
      id: 'most_inc',
      description: 'most_inc-desc',
    },
    'not-most_inc': {
      value: 'not-most_inc',
      label: 'not-most_inc',
      id: 'not-most_inc',
      description: 'not-most_inc-desc',
    },
    least: {
      value: 'least',
      label: 'least',
      id: 'least',
      description: 'least-desc',
    },
    'not-least': {
      value: 'not-least',
      label: 'not-least',
      id: 'not-least',
      description: 'not-least-desc',
    },
    least_inc: {
      value: 'least_inc',
      label: 'least_inc',
      id: 'least_inc',
      description: 'least_inc-desc',
    },
    'not-least_inc': {
      value: 'not-least_inc',
      label: 'not-least_inc',
      id: 'not-least_inc',
      description: 'not-least_inc-desc',
    },
    contains: {
      value: 'contains',
      label: 'contains',
      id: 'contains',
      description: 'contains-desc',
    },
    'not-contains': {
      value: 'not-contains',
      label: 'not-contains',
      id: 'not-contains',
      description: 'not-contains-desc',
    },
  };

  static list = Object.values(this.map);
}

export class TypeDateOptions {
  static enum = {
    SPECIFICDATE: 'specific_date',
    PREVIOUSY: 'previousY',
    NOT_PREVIOUSY: 'not-previousY',
    PREVIOUSM: 'previousM',
    NOT_PREVIOUSM: 'not-previousM',
    PREVIOUSD: 'previousD',
    NOT_PREVIOUSD: 'not-previousD',
    PREVIOUSQ: 'previousQ',
    NOT_PREVIOUSQ: 'not-previousQ',
    PREVIOUSS: 'previousS',
    NOT_PREVIOUSS: 'not-previousS',
    PREVIOUSW: 'previousW',
    NOT_PREVIOUSW: 'not-previousW',
    CURRENTAND_PREVIOUSY: 'current_and_previousY',
    NOT_CURRENTAND_PREVIOUSY: 'not-current_and_previousY',
    CURRENTAND_PREVIOUSM: 'current_and_previousM',
    NOT_CURRENTAND_PREVIOUSM: 'not-current_and_previousM',
    CURRENTAND_PREVIOUSD: 'current_and_previousD',
    NOT_CURRENTAND_PREVIOUSD: 'not-current_and_previousD',
    CURRENTAND_PREVIOUSQ: 'current_and_previousQ',
    NOT_CURRENTAND_PREVIOUSQ: 'not-current_and_previousQ',
    CURRENTAND_PREVIOUSS: 'current_and_previousS',
    NOT_CURRENTAND_PREVIOUSS: 'not-current_and_previousS',
    CURRENTAND_PREVIOUSW: 'current_and_previousW',
    NOT_CURRENTAND_PREVIOUSW: 'not-current_and_previousW',
    FOLLOWINGY: 'followingY',
    NOT_FOLLOWINGY: 'not-followingY',
    FOLLOWINGM: 'followingM',
    NOT_FOLLOWINGM: 'not-followingM',
    FOLLOWINGD: 'followingD',
    NOT_FOLLOWINGD: 'not-followingD',
    FOLLOWINGQ: 'followingQ',
    NOT_FOLLOWINGQ: 'not-followingQ',
    FOLLOWINGS: 'followingS',
    NOT_FOLLOWINGS: 'not-followingS',
    FOLLOWINGW: 'followingW',
    NOT_FOLLOWINGW: 'not-followingW',
    CURRENTAND_FOLLOWINGY: 'current_and_followingY',
    NOT_CURRENTAND_FOLLOWINGY: 'not-current_and_followingY',
    CURRENTAND_FOLLOWINGM: 'current_and_followingM',
    NOT_CURRENTAND_FOLLOWINGM: 'not-current_and_followingM',
    CURRENTAND_FOLLOWINGD: 'current_and_followingD',
    NOT_CURRENTAND_FOLLOWINGD: 'not-current_and_followingD',
    CURRENTAND_FOLLOWINGQ: 'current_and_followingQ',
    NOT_CURRENTAND_FOLLOWINGQ: 'not-current_and_followingQ',
    CURRENTAND_FOLLOWINGS: 'current_and_followingS',
    NOT_CURRENTAND_FOLLOWINGS: 'not-current_and_followingS',
    CURRENTAND_FOLLOWINGW: 'current_and_followingW',
    NOT_CURRENTAND_FOLLOWINGW: 'not-current_and_followingW',
    LASTY: 'lastY',
    NOT_LASTY: 'not-lastY',
    LASTM: 'lastM',
    NOT_LASTM: 'not-lastM',
    LASTD: 'lastD',
    NOT_LASTD: 'not-lastD',
    LASTQ: 'lastQ',
    NOT_LASTQ: 'not-lastQ',
    LASTS: 'lastS',
    NOT_LASTS: 'not-lastS',
    LASTW: 'lastW',
    NOT_LASTW: 'not-lastW',
    NEXTY: 'nextY',
    NOT_NEXTY: 'not-nextY',
    NEXTM: 'nextM',
    NOT_NEXTM: 'not-nextM',
    NEXTD: 'nextD',
    NOT_NEXTD: 'not-nextD',
    NEXTQ: 'nextQ',
    NOT_NEXTQ: 'not-nextQ',
    NEXTS: 'nextS',
    NOT_NEXTS: 'not-nextS',
    NEXTW: 'nextW',
    NOT_NEXTW: 'not-nextW',
    AFTER: 'after',
    BEFORE: 'before',
    BETWEEN: 'between',
    NOT_BETWEENINC: 'not-between_inc',
    AFTERINC: 'after_inc',
    BEFOREINC: 'before_inc',
    BETWEENINC: 'between_inc',
    NOT_BETWEEN: 'not-between',
  } as const;

  static map: OptionsMap<typeof this.enum> = {
    specific_date: {
      value: 'specific_date',
      label: 'specific_date',
      id: 'specific_date',
      description: 'specific_date-desc',
    },
    // n anteriores
    previousY: {
      value: 'previousY',
      label: 'previousY',
      id: 'previousY',
      description: 'previousY-desc',
      params: {
        ini: getDynamicDateRange('previousY', 2).firstInterval.startDate,
        end: getDynamicDateRange('previousY', 2).firstInterval.endDate,
      },
    },
    'not-previousY': {
      value: 'not-previousY',
      label: 'not-previousY',
      id: 'not-previousY',
      description: 'not-previousY-desc',
      params: {
        ini: getDynamicDateRange('not-previousY', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-previousY', 2).secondInterval.startDate,
      },
    },
    previousM: {
      value: 'previousM',
      label: 'previousM',
      id: 'previousM',
      description: 'previousM-desc',
      params: {
        ini: getDynamicDateRange('previousM', 2).firstInterval.startDate,
        end: getDynamicDateRange('previousM', 2).firstInterval.endDate,
      },
    },
    'not-previousM': {
      value: 'not-previousM',
      label: 'not-previousM',
      id: 'not-previousM',
      description: 'not-previousM-desc',
      params: {
        ini: getDynamicDateRange('not-previousM', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-previousM', 2).secondInterval.startDate,
      },
    },
    previousD: {
      value: 'previousD',
      label: 'previousD',
      id: 'previousD',
      description: 'previousD-desc',
      params: {
        ini: getDynamicDateRange('previousD', 2).firstInterval.startDate,
        end: getDynamicDateRange('previousD', 2).firstInterval.endDate,
      },
    },
    'not-previousD': {
      value: 'not-previousD',
      label: 'not-previousD',
      id: 'not-previousD',
      description: 'not-previousD-desc',
      params: {
        ini: getDynamicDateRange('not-previousD', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-previousD', 2).secondInterval.startDate,
      },
    },
    previousQ: {
      value: 'previousQ',
      label: 'previousQ',
      id: 'previousQ',
      description: 'previousQ-desc',
      params: {
        ini: getDynamicDateRange('previousQ', 2).firstInterval.startDate,
        end: getDynamicDateRange('previousQ', 2).firstInterval.endDate,
      },
    },
    'not-previousQ': {
      value: 'not-previousQ',
      label: 'not-previousQ',
      id: 'not-previousQ',
      description: 'not-previousQ-desc',
      params: {
        ini: getDynamicDateRange('not-previousQ', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-previousQ', 2).secondInterval.startDate,
      },
    },
    previousS: {
      value: 'previousS',
      label: 'previousS',
      id: 'previousS',
      description: 'previousS-desc',
      params: {
        ini: getDynamicDateRange('previousS', 2).firstInterval.startDate,
        end: getDynamicDateRange('previousS', 2).firstInterval.endDate,
      },
    },
    'not-previousS': {
      value: 'not-previousS',
      label: 'not-previousS',
      id: 'not-previousS',
      description: 'not-previousS-desc',
      params: {
        ini: getDynamicDateRange('not-previousS', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-previousS', 2).secondInterval.startDate,
      },
    },
    previousW: {
      value: 'previousW',
      label: 'previousW',
      id: 'previousW',
      description: 'previousW-desc',
      params: {
        ini: getDynamicDateRange('previousW', 2).firstInterval.startDate,
        end: getDynamicDateRange('previousW', 2).firstInterval.endDate,
      },
    },
    'not-previousW': {
      value: 'not-previousW',
      label: 'not-previousW',
      id: 'not-previousW',
      description: 'not-previousW-desc',
      params: {
        ini: getDynamicDateRange('not-previousW', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-previousW', 2).secondInterval.startDate,
      },
    },
    // atual e n anteriores
    current_and_previousY: {
      value: 'current_and_previousY',
      label: 'current_and_previousY',
      id: 'current_and_previousY',
      description: 'current_and_previousY-desc',
      params: {
        ini: getDynamicDateRange('current_and_previousY', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_previousY', 2).firstInterval.endDate,
      },
    },
    'not-current_and_previousY': {
      value: 'not-current_and_previousY',
      label: 'not-current_and_previousY',
      id: 'not-current_and_previousY',
      description: 'not-current_and_previousY-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_previousY', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_previousY', 2).secondInterval.startDate,
      },
    },
    current_and_previousM: {
      value: 'current_and_previousM',
      label: 'current_and_previousM',
      id: 'current_and_previousM',
      description: 'current_and_previousM-desc',
      params: {
        ini: getDynamicDateRange('current_and_previousM', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_previousM', 2).firstInterval.endDate,
      },
    },
    'not-current_and_previousM': {
      value: 'not-current_and_previousM',
      label: 'not-current_and_previousM',
      id: 'not-current_and_previousM',
      description: 'not-current_and_previousM-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_previousM', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_previousM', 2).secondInterval.startDate,
      },
    },
    current_and_previousD: {
      value: 'current_and_previousD',
      label: 'current_and_previousD',
      id: 'current_and_previousD',
      description: 'current_and_previousD-desc',
      params: {
        ini: getDynamicDateRange('current_and_previousD', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_previousD', 2).firstInterval.endDate,
      },
    },
    'not-current_and_previousD': {
      value: 'not-current_and_previousD',
      label: 'not-current_and_previousD',
      id: 'not-current_and_previousD',
      description: 'not-current_and_previousD-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_previousD', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_previousD', 2).secondInterval.startDate,
      },
    },
    current_and_previousQ: {
      value: 'current_and_previousQ',
      label: 'current_and_previousQ',
      id: 'current_and_previousQ',
      description: 'current_and_previousQ-desc',
      params: {
        ini: getDynamicDateRange('current_and_previousQ', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_previousQ', 2).firstInterval.endDate,
      },
    },
    'not-current_and_previousQ': {
      value: 'not-current_and_previousQ',
      label: 'not-current_and_previousQ',
      id: 'not-current_and_previousQ',
      description: 'not-current_and_previousQ-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_previousQ', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_previousQ', 2).secondInterval.startDate,
      },
    },
    current_and_previousS: {
      value: 'current_and_previousS',
      label: 'current_and_previousS',
      id: 'current_and_previousS',
      description: 'current_and_previousS-desc',
      params: {
        ini: getDynamicDateRange('current_and_previousS', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_previousS', 2).firstInterval.endDate,
      },
    },
    'not-current_and_previousS': {
      value: 'not-current_and_previousS',
      label: 'not-current_and_previousS',
      id: 'not-current_and_previousS',
      description: 'not-current_and_previousS-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_previousS', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_previousS', 2).secondInterval.startDate,
      },
    },
    current_and_previousW: {
      value: 'current_and_previousW',
      label: 'current_and_previousW',
      id: 'current_and_previousW',
      description: 'current_and_previousW-desc',
      params: {
        ini: getDynamicDateRange('current_and_previousW', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_previousW', 2).firstInterval.endDate,
      },
    },
    'not-current_and_previousW': {
      value: 'not-current_and_previousW',
      label: 'not-current_and_previousW',
      id: 'not-current_and_previousW',
      description: 'not-current_and_previousW-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_previousW', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_previousW', 2).secondInterval.startDate,
      },
    },
    // n seguintes
    followingY: {
      value: 'followingY',
      label: 'followingY',
      id: 'followingY',
      description: 'followingY-desc',
      params: {
        ini: getDynamicDateRange('followingY', 2).firstInterval.startDate,
        end: getDynamicDateRange('followingY', 2).firstInterval.endDate,
      },
    },
    'not-followingY': {
      value: 'not-followingY',
      label: 'not-followingY',
      id: 'not-followingY',
      description: 'not-followingY-desc',
      params: {
        ini: getDynamicDateRange('not-followingY', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-followingY', 2).secondInterval.startDate,
      },
    },
    followingM: {
      value: 'followingM',
      label: 'followingM',
      id: 'followingM',
      description: 'followingM-desc',
      params: {
        ini: getDynamicDateRange('followingM', 2).firstInterval.startDate,
        end: getDynamicDateRange('followingM', 2).firstInterval.endDate,
      },
    },
    'not-followingM': {
      value: 'not-followingM',
      label: 'not-followingM',
      id: 'not-followingM',
      description: 'not-followingM-desc',
      params: {
        ini: getDynamicDateRange('not-followingM', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-followingM', 2).secondInterval.startDate,
      },
    },
    followingD: {
      value: 'followingD',
      label: 'followingD',
      id: 'followingD',
      description: 'followingD-desc',
      params: {
        ini: getDynamicDateRange('followingD', 2).firstInterval.startDate,
        end: getDynamicDateRange('followingD', 2).firstInterval.endDate,
      },
    },
    'not-followingD': {
      value: 'not-followingD',
      label: 'not-followingD',
      id: 'not-followingD',
      description: 'not-followingD-desc',
      params: {
        ini: getDynamicDateRange('not-followingD', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-followingD', 2).secondInterval.startDate,
      },
    },
    followingQ: {
      value: 'followingQ',
      label: 'followingQ',
      id: 'followingQ',
      description: 'followingQ-desc',
      params: {
        ini: getDynamicDateRange('followingQ', 2).firstInterval.startDate,
        end: getDynamicDateRange('followingQ', 2).firstInterval.endDate,
      },
    },
    'not-followingQ': {
      value: 'not-followingQ',
      label: 'not-followingQ',
      id: 'not-followingQ',
      description: 'not-followingQ-desc',
      params: {
        ini: getDynamicDateRange('not-followingQ', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-followingQ', 2).secondInterval.startDate,
      },
    },
    followingS: {
      value: 'followingS',
      label: 'followingS',
      id: 'followingS',
      description: 'followingS-desc',
      params: {
        ini: getDynamicDateRange('followingS', 2).firstInterval.startDate,
        end: getDynamicDateRange('followingS', 2).firstInterval.endDate,
      },
    },
    'not-followingS': {
      value: 'not-followingS',
      label: 'not-followingS',
      id: 'not-followingS',
      description: 'not-followingS-desc',
      params: {
        ini: getDynamicDateRange('not-followingS', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-followingS', 2).secondInterval.startDate,
      },
    },
    followingW: {
      value: 'followingW',
      label: 'followingW',
      id: 'followingW',
      description: 'followingW-desc',
      params: {
        ini: getDynamicDateRange('followingW', 2).firstInterval.startDate,
        end: getDynamicDateRange('followingW', 2).firstInterval.endDate,
      },
    },
    'not-followingW': {
      value: 'not-followingW',
      label: 'not-followingW',
      id: 'not-followingW',
      description: 'not-followingW-desc',
      params: {
        ini: getDynamicDateRange('not-followingW', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-followingW', 2).secondInterval.startDate,
      },
    },
    // atual e próximos n
    current_and_followingY: {
      value: 'current_and_followingY',
      label: 'current_and_followingY',
      id: 'current_and_followingY',
      description: 'current_and_followingY-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingY', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingY', 2).firstInterval.endDate,
      },
    },
    'not-current_and_followingY': {
      value: 'not-current_and_followingY',
      label: 'not-current_and_followingY',
      id: 'not-current_and_followingY',
      description: 'not-current_and_followingY-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_followingY', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_followingY', 2).secondInterval.startDate,
      },
    },
    current_and_followingM: {
      value: 'current_and_followingM',
      label: 'current_and_followingM',
      id: 'current_and_followingM',
      description: 'current_and_followingM-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingM', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingM', 2).firstInterval.endDate,
      },
    },
    'not-current_and_followingM': {
      value: 'not-current_and_followingM',
      label: 'not-current_and_followingM',
      id: 'not-current_and_followingM',
      description: 'not-current_and_followingM-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_followingM', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_followingM', 2).secondInterval.startDate,
      },
    },
    current_and_followingD: {
      value: 'current_and_followingD',
      label: 'current_and_followingD',
      id: 'current_and_followingD',
      description: 'current_and_followingD-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingD', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingD', 2).firstInterval.endDate,
      },
    },
    'not-current_and_followingD': {
      value: 'not-current_and_followingD',
      label: 'not-current_and_followingD',
      id: 'not-current_and_followingD',
      description: 'not-current_and_followingD-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_followingD', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_followingD', 2).secondInterval.startDate,
      },
    },
    current_and_followingQ: {
      value: 'current_and_followingQ',
      label: 'current_and_followingQ',
      id: 'current_and_followingQ',
      description: 'current_and_followingQ-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingQ', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingQ', 2).firstInterval.endDate,
      },
    },
    'not-current_and_followingQ': {
      value: 'not-current_and_followingQ',
      label: 'not-current_and_followingQ',
      id: 'not-current_and_followingQ',
      description: 'not-current_and_followingQ-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_followingQ', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_followingQ', 2).secondInterval.startDate,
      },
    },
    current_and_followingS: {
      value: 'current_and_followingS',
      label: 'current_and_followingS',
      id: 'current_and_followingS',
      description: 'current_and_followingS-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingS', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingS', 2).firstInterval.endDate,
      },
    },
    'not-current_and_followingS': {
      value: 'not-current_and_followingS',
      label: 'not-current_and_followingS',
      id: 'not-current_and_followingS',
      description: 'not-current_and_followingS-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_followingS', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_followingS', 2).secondInterval.startDate,
      },
    },
    current_and_followingW: {
      value: 'current_and_followingW',
      label: 'current_and_followingW',
      id: 'current_and_followingW',
      description: 'current_and_followingW-desc',
      params: {
        ini: getDynamicDateRange('current_and_followingW', 2).firstInterval.startDate,
        end: getDynamicDateRange('current_and_followingW', 2).firstInterval.endDate,
      },
    },
    'not-current_and_followingW': {
      value: 'not-current_and_followingW',
      label: 'not-current_and_followingW',
      id: 'not-current_and_followingW',
      description: 'not-current_and_followingW-desc',
      params: {
        ini: getDynamicDateRange('not-current_and_followingW', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-current_and_followingW', 2).secondInterval.startDate,
      },
    },
    lastY: {
      value: 'lastY',
      label: 'lastY',
      id: 'lastY',
      description: 'lastY-desc',
      params: {
        ini: getDynamicDateRange('lastY', 2).firstInterval.startDate,
        end: getDynamicDateRange('lastY', 2).firstInterval.endDate,
      },
    },
    'not-lastY': {
      value: 'not-lastY',
      label: 'not-lastY',
      id: 'not-lastY',
      description: 'not-lastY-desc',
      params: {
        ini: getDynamicDateRange('not-lastY', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-lastY', 2).secondInterval.startDate,
      },
    },
    lastM: {
      value: 'lastM',
      label: 'lastM',
      id: 'lastM',
      description: 'lastM-desc',
      params: {
        ini: getDynamicDateRange('lastM', 2).firstInterval.startDate,
        end: getDynamicDateRange('lastM', 2).firstInterval.endDate,
      },
    },
    'not-lastM': {
      value: 'not-lastM',
      label: 'not-lastM',
      id: 'not-lastM',
      description: 'not-lastM-desc',
      params: {
        ini: getDynamicDateRange('not-lastM', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-lastM', 2).secondInterval.startDate,
      },
    },
    lastD: {
      value: 'lastD',
      label: 'lastD',
      id: 'lastD',
      description: 'lastD-desc',
      params: {
        ini: getDynamicDateRange('lastD', 2).firstInterval.startDate,
        end: getDynamicDateRange('lastD', 2).firstInterval.endDate,
      },
    },
    'not-lastD': {
      value: 'not-lastD',
      label: 'not-lastD',
      id: 'not-lastD',
      description: 'not-lastD-desc',
      params: {
        ini: getDynamicDateRange('not-lastD', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-lastD', 2).secondInterval.startDate,
      },
    },
    lastQ: {
      value: 'lastQ',
      label: 'lastQ',
      id: 'lastQ',
      description: 'lastQ-desc',
      params: {
        ini: getDynamicDateRange('lastQ', 2).firstInterval.startDate,
        end: getDynamicDateRange('lastQ', 2).firstInterval.endDate,
      },
    },
    'not-lastQ': {
      value: 'not-lastQ',
      label: 'not-lastQ',
      id: 'not-lastQ',
      description: 'not-lastQ-desc',
      params: {
        ini: getDynamicDateRange('not-lastQ', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-lastQ', 2).secondInterval.startDate,
      },
    },
    lastS: {
      value: 'lastS',
      label: 'lastS',
      id: 'lastS',
      description: 'lastS-desc',
      params: {
        ini: getDynamicDateRange('lastS', 2).firstInterval.startDate,
        end: getDynamicDateRange('lastS', 2).firstInterval.endDate,
      },
    },
    'not-lastS': {
      value: 'not-lastS',
      label: 'not-lastS',
      id: 'not-lastS',
      description: 'not-lastS-desc',
      params: {
        ini: getDynamicDateRange('not-lastS', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-lastS', 2).secondInterval.startDate,
      },
    },
    lastW: {
      value: 'lastW',
      label: 'lastW',
      id: 'lastW',
      description: 'lastW-desc',
      params: {
        ini: getDynamicDateRange('lastW', 2).firstInterval.startDate,
        end: getDynamicDateRange('lastW', 2).firstInterval.endDate,
      },
    },
    'not-lastW': {
      value: 'not-lastW',
      label: 'not-lastW',
      id: 'not-lastW',
      description: 'not-lastW-desc',
      params: {
        ini: getDynamicDateRange('not-lastW', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-lastW', 2).secondInterval.startDate,
      },
    },
    nextY: {
      value: 'nextY',
      label: 'nextY',
      id: 'nextY',
      description: 'nextY-desc',
      params: {
        ini: getDynamicDateRange('nextY', 2).firstInterval.startDate,
        end: getDynamicDateRange('nextY', 2).firstInterval.endDate,
      },
    },
    'not-nextY': {
      value: 'not-nextY',
      label: 'not-nextY',
      id: 'not-nextY',
      description: 'not-nextY-desc',
      params: {
        ini: getDynamicDateRange('not-nextY', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-nextY', 2).secondInterval.startDate,
      },
    },
    nextM: {
      value: 'nextM',
      label: 'nextM',
      id: 'nextM',
      description: 'nextM-desc',
      params: {
        ini: getDynamicDateRange('nextM', 2).firstInterval.startDate,
        end: getDynamicDateRange('nextM', 2).firstInterval.endDate,
      },
    },
    'not-nextM': {
      value: 'not-nextM',
      label: 'not-nextM',
      id: 'not-nextM',
      description: 'not-nextM-desc',
      params: {
        ini: getDynamicDateRange('not-nextM', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-nextM', 2).secondInterval.startDate,
      },
    },
    nextD: {
      value: 'nextD',
      label: 'nextD',
      id: 'nextD',
      description: 'nextD-desc',
      params: {
        ini: getDynamicDateRange('nextD', 2).firstInterval.startDate,
        end: getDynamicDateRange('nextD', 2).firstInterval.endDate,
      },
    },
    'not-nextD': {
      value: 'not-nextD',
      label: 'not-nextD',
      id: 'not-nextD',
      description: 'not-nextD-desc',
      params: {
        ini: getDynamicDateRange('not-nextD', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-nextD', 2).secondInterval.startDate,
      },
    },
    nextQ: {
      value: 'nextQ',
      label: 'nextQ',
      id: 'nextQ',
      description: 'nextQ-desc',
      params: {
        ini: getDynamicDateRange('nextQ', 2).firstInterval.startDate,
        end: getDynamicDateRange('nextQ', 2).firstInterval.endDate,
      },
    },
    'not-nextQ': {
      value: 'not-nextQ',
      label: 'not-nextQ',
      id: 'not-nextQ',
      description: 'not-nextQ-desc',
      params: {
        ini: getDynamicDateRange('not-nextQ', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-nextQ', 2).secondInterval.startDate,
      },
    },
    nextS: {
      value: 'nextS',
      label: 'nextS',
      id: 'nextS',
      description: 'nextS-desc',
      params: {
        ini: getDynamicDateRange('nextS', 2).firstInterval.startDate,
        end: getDynamicDateRange('nextS', 2).firstInterval.endDate,
      },
    },
    'not-nextS': {
      value: 'not-nextS',
      label: 'not-nextS',
      id: 'not-nextS',
      description: 'not-nextS-desc',
      params: {
        ini: getDynamicDateRange('not-nextS', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-nextS', 2).secondInterval.startDate,
      },
    },
    nextW: {
      value: 'nextW',
      label: 'nextW',
      id: 'nextW',
      description: 'nextW-desc',
      params: {
        ini: getDynamicDateRange('nextW', 2).firstInterval.startDate,
        end: getDynamicDateRange('nextW', 2).firstInterval.endDate,
      },
    },
    'not-nextW': {
      value: 'not-nextW',
      label: 'not-nextW',
      id: 'not-nextW',
      description: 'not-nextW-desc',
      params: {
        ini: getDynamicDateRange('not-nextW', 2).firstInterval.endDate,
        end: getDynamicDateRange('not-nextW', 2).secondInterval.startDate,
      },
    },
    // entre datas
    after: {
      value: 'after',
      label: 'after',
      id: 'after',
      description: 'after-desc',
    },
    before: {
      value: 'before',
      label: 'before',
      id: 'before',
      description: 'before-desc',
    },
    between: {
      value: 'between',
      label: 'between-date',
      id: 'between',
      description: 'between-date-desc',
    },
    'not-between_inc': {
      value: 'not-between_inc',
      label: 'not-between-date_inc',
      id: 'not-between_inc',
      description: 'not-between-date_inc-desc',
    },
    after_inc: {
      value: 'after_inc',
      label: 'after_inc',
      id: 'after_inc',
      description: 'after_inc-desc',
    },
    before_inc: {
      value: 'before_inc',
      label: 'before_inc',
      id: 'before_inc',
      description: 'before_inc-desc',
    },
    between_inc: {
      value: 'between_inc',
      label: 'between-date_inc',
      id: 'between_inc',
      description: 'between-date_inc-desc',
    },
    'not-between': {
      value: 'not-between',
      label: 'not-between-date',
      id: 'not-between',
      description: 'not-between-date-desc',
    },
  };

  static list = Object.values(this.map);
}
